export * from "react-router-dom";
export { BrowserRouter as Router } from "react-router-dom";

/**
 * Web does not have the Android back button component, so we put a stub in place.
 */
export const BackButton = (props) => props.children;
